/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useAuth } from "cms/auth/hooks/use-auth";
import { useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { isValidGuid } from "utils/empty-exists";
import { CardsImage } from "./image";
import { formatDateGeneralShort } from "utils/date-format";
import { isRichText } from "cms/rich-text/richtext-utils";
import { Logger } from "cms/utils/log/logger";

const CardsItemDisplay = (props) => {
    const { token } = useAuth();
    const { item } = props || {};
    
    const date = item?.date;
    if (isRichText(item?.description)) {
        Logger.warn("Description contained RichText. should be text");
    }
    const description = isRichText(item?.description) ? "" : item?.description;
    const heading = item?.heading;
    const image_guid = item?.image;
    const link_guid = item?.link;
    const [image, setImage] = useState();
    const [link, setLink] = useState();

    useEffect(() => {
        const fetch = async () => {
            if (!image) {
                if (image_guid && isValidGuid(image_guid)) {
                    const img = await SimpliCityAdminSDK.images.findOne(token, image_guid);
                    setImage(img);
                }
            }
            if (!link) {
                if (link_guid && isValidGuid(link_guid)) {
                    const lnk = await SimpliCityAdminSDK.link.findOne(token, link_guid);
                    setLink(lnk);
                }
            }
        };
        fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, image_guid, link_guid]);

    return (
        <div className="simplicity-cards-item-display">
            {image && (
                <div className="simplicity-cards-item-display-image">
                    <CardsImage image={image} />
                </div>
            )}
            {date && <div className="simplicity-cards-item-display-date">{formatDateGeneralShort(date)}</div>}
            {heading && <div className="simplicity-cards-item-display-heading">{heading}</div>}
            {description && (
                <div className="simplicity-cards-item-display-description">{description}</div>
            )}
            {link?.text && link?.url && (
                <div className="simplicity-cards-item-display-link">
                    <a href={link?.url}>{link?.text}</a>
                </div>
            )}
        </div>
    );
};

export { CardsItemDisplay };
